import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../services/api";
import { setToastOk } from "../main/mainSlice";

const initialState = {};

export const login = createAsyncThunk(
  "auth/login",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/admins/login", payload);
      return response.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response?.data || "Không thể đăng nhập. Vui lòng thử lại.",
        }),
      );
      return rejectWithValue(error.response?.data || "Không thể đăng nhập. Vui lòng thử lại.");
    }
  },
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (auth) => {
    auth
      .addCase(login.pending, (state) => {})
      .addCase(login.fulfilled, (state, action) => {
        window.location.href = "/";
      })
      .addCase(login.rejected, (state, action) => {});
  },
});

export const {} = authSlice.actions;

export default authSlice.reducer;
